import {
  IMusselLineDetail,
  IOysterLineDetail,
  ISeaweedLineDetail,
} from '../../entities/farms.entities';
import { ICycleResource } from '../../entities/growing.entities';
import MusselLineMobile from './MusselLineMobile';
import OysterLineMobile from './OysterLineMobile';
import SeaweedLineMobile from './SeaweedLineMobile';
import FlupsyMusselLineMobile from './FlupsyMusselLineMobile';
import FlupsyOysterLineMobile from './FlupsyOysterLineMobile';

interface Props {
  lineData: IMusselLineDetail | IOysterLineDetail | ISeaweedLineDetail;
  cyclePart?: ICycleResource | null;
  isPrevEnabled: boolean;
  isNextEnabled: boolean;
  onClickPrevGroup: () => void;
  onClickNextGroup: () => void;
  showEditLineModal: () => void;
  onSeedingClick: () => void;
  onAssessmentClick: () => void;
  onCatchSpatClick: () => void;
  onHarvestClick: () => void;
  onReturnClick: () => void;
  onMaintenanceClick: () => void;
  onFloatingManageClick: () => void; // only for MUSSEL
  onExtraSeedClick: () => void;
  onMetaEditClick: () => void;
  checkedHistoryView: number; // only for MUSSEL
  onHistoryViewClick: () => void; // only for MUSSEL
  onWasteClick: () => void;
}

const LineTemplateMobile = ({
  lineData,
  cyclePart,
  isPrevEnabled,
  isNextEnabled,
  onClickPrevGroup,
  onClickNextGroup,
  showEditLineModal,
  onSeedingClick,
  onAssessmentClick,
  onCatchSpatClick,
  onHarvestClick,
  onReturnClick,
  onMaintenanceClick,
  onFloatingManageClick,
  onExtraSeedClick,
  onMetaEditClick,
  checkedHistoryView,
  onHistoryViewClick,
  onWasteClick,
}: Props) =>
  lineData.farm_is_flupsy ? (
    <>
      {lineData.crop_type === 'MUSSEL' && (
        <FlupsyMusselLineMobile
          lineData={lineData as IMusselLineDetail}
          cyclePart={cyclePart}
          isPrevEnabled={isPrevEnabled}
          isNextEnabled={isNextEnabled}
          onClickPrevGroup={onClickPrevGroup}
          onClickNextGroup={onClickNextGroup}
          showEditLineModal={showEditLineModal}
          onSeedingClick={onSeedingClick}
          onAssessmentClick={onAssessmentClick}
          onCatchSpatClick={onCatchSpatClick}
          onHarvestClick={onHarvestClick}
          onMaintenanceClick={onMaintenanceClick}
          onFloatingManageClick={onFloatingManageClick}
          onExtraSeedClick={onExtraSeedClick}
          onMetaEditClick={onMetaEditClick}
          checkedHistoryView={checkedHistoryView}
          onHistoryViewClick={onHistoryViewClick}
          onWasteClick={onWasteClick}
        />
      )}

      {lineData.crop_type === 'OYSTER' && (
        <FlupsyOysterLineMobile
          lineData={lineData as IOysterLineDetail}
          cyclePart={cyclePart}
          isPrevEnabled={isPrevEnabled}
          isNextEnabled={isNextEnabled}
          onClickPrevGroup={onClickPrevGroup}
          onClickNextGroup={onClickNextGroup}
          showEditLineModal={showEditLineModal}
          onSeedingClick={onSeedingClick}
          onAssessmentClick={onAssessmentClick}
          onCatchSpatClick={onCatchSpatClick}
          onHarvestClick={onHarvestClick}
          onMaintenanceClick={onMaintenanceClick}
          onExtraSeedClick={onExtraSeedClick}
          onFloatingManageClick={onFloatingManageClick}
          onMetaEditClick={onMetaEditClick}
          checkedHistoryView={checkedHistoryView}
          onHistoryViewClick={onHistoryViewClick}
        />
      )}
    </>
  ) : (
    <>
      {lineData.crop_type === 'MUSSEL' ? (
        <MusselLineMobile
          lineData={lineData as IMusselLineDetail}
          cyclePart={cyclePart}
          isPrevEnabled={isPrevEnabled}
          isNextEnabled={isNextEnabled}
          onClickPrevGroup={onClickPrevGroup}
          onClickNextGroup={onClickNextGroup}
          showEditLineModal={showEditLineModal}
          onSeedingClick={onSeedingClick}
          onAssessmentClick={onAssessmentClick}
          onCatchSpatClick={onCatchSpatClick}
          onHarvestClick={onHarvestClick}
          onReturnClick={onReturnClick}
          onMaintenanceClick={onMaintenanceClick}
          onFloatingManageClick={onFloatingManageClick}
          onExtraSeedClick={onExtraSeedClick}
          onMetaEditClick={onMetaEditClick}
          checkedHistoryView={checkedHistoryView}
          onHistoryViewClick={onHistoryViewClick}
          onWasteClick={onWasteClick}
        />
      ) : lineData.crop_type === 'OYSTER' ? (
        <OysterLineMobile
          lineData={lineData as IOysterLineDetail}
          cyclePart={cyclePart}
          isPrevEnabled={isPrevEnabled}
          isNextEnabled={isNextEnabled}
          onClickPrevGroup={onClickPrevGroup}
          onClickNextGroup={onClickNextGroup}
          showEditLineModal={showEditLineModal}
          onSeedingClick={onSeedingClick}
          onAssessmentClick={onAssessmentClick}
          onCatchSpatClick={onCatchSpatClick}
          onHarvestClick={onHarvestClick}
          onReturnClick={onReturnClick}
          onMaintenanceClick={onMaintenanceClick}
          onExtraSeedClick={onExtraSeedClick}
          onFloatingManageClick={onFloatingManageClick}
          onMetaEditClick={onMetaEditClick}
          checkedHistoryView={checkedHistoryView}
          onHistoryViewClick={onHistoryViewClick}
        />
      ) : (
        <SeaweedLineMobile
          lineData={lineData as ISeaweedLineDetail}
          cyclePart={cyclePart}
          isPrevEnabled={isPrevEnabled}
          isNextEnabled={isNextEnabled}
          onClickPrevGroup={onClickPrevGroup}
          onClickNextGroup={onClickNextGroup}
          showEditLineModal={showEditLineModal}
          onSeedingClick={onSeedingClick}
          onAssessmentClick={onAssessmentClick}
          onCatchSpatClick={onCatchSpatClick}
          onHarvestClick={onHarvestClick}
          onReturnClick={onReturnClick}
          onMaintenanceClick={onMaintenanceClick}
          onExtraSeedClick={onExtraSeedClick}
          onMetaEditClick={onMetaEditClick}
        />
      )}
    </>
  );

export default LineTemplateMobile;
